var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"params"},[_c('div',{staticClass:"table-btns"}),_c('a-form-model',{ref:"modalForm",staticClass:"form-in-twocolumns",staticStyle:{"margin-top":"5%"},attrs:{"layout":"inline","label-col":{span:9},"wrapper-col":{span:14}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }